export const state = () => ({
  showSpinner: false
});

export const getters = {
  showSpinner: state => state.showSpinner
};
export const mutations = {
  SET_SPINNER: function(rootState, showSpinner) {
    rootState.showSpinner = showSpinner;
  }
};
export const actions = {
  setalert({ commit, showSpinner }) {
    commit("SET_SPINNER", showSpinner);
  }
};
